import React from 'react';

import mapboxgl from 'mapbox-gl';

import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import { AppV2 } from './components/AppV2/AppV2';
import { isV2LayoutEnabled } from './helpers/featureFlags/isV2LayoutEnabled';
import * as serviceWorker from './serviceWorker';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN.trim();

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(isV2LayoutEnabled() ? <AppV2 /> : <App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
